// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "closeIcon-te75K";
export { _1 as "__esModule", _2 as "closeIcon" }
export default { "__esModule": _1, "closeIcon": _2 }
